import { render, staticRenderFns } from "./approved-students.vue?vue&type=template&id=511fbd24&"
import script from "./approved-students.vue?vue&type=script&lang=js&"
export * from "./approved-students.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "approved-students.vue"
export default component.exports